import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Loader2, ShieldAlert } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { MetricCards, PendingList } from "@/components/admin/MetricCards";
import { DailyChart } from "@/components/admin/DailyChart";
import { AuditList, ConfigControls, ExtraInvites } from "@/components/admin/AdminControls";
import { UsersTab } from "@/components/admin/UsersTab";

const TABS = [["resumen", "Resumen"], ["usuarios", "Usuarios"]];

export default function MetricasPage() {
  const [m, setM] = useState(null);
  const [audit, setAudit] = useState([]);
  const [err, setErr] = useState(null);
  const [tab, setTab] = useState("resumen");
  const load = useCallback(async () => {
    try {
      const [a, b] = await Promise.all([api.get("/admin/metricas"), api.get("/admin/auditoria")]);
      setM(a.data); setAudit(b.data.items);
    } catch (e) { setErr(e.response?.status === 403 ? "forbidden" : errMsg(e)); }
  }, []);
  useEffect(() => { load(); }, [load]);
  return (
    <div data-testid="admin-metricas-page" className="min-h-screen bg-[var(--c-bg)]">
      <div className={`${tab === "usuarios" ? "max-w-md md:max-w-6xl" : "max-w-md"} mx-auto px-4 py-5 space-y-3`}>
        <div className="flex items-center gap-2">
          <Link to="/conecta/mas" data-testid="admin-back-link" className="p-1.5 -ml-1.5 rounded-lg"><ArrowLeft className="w-5 h-5" /></Link>
          <div>
            <h1 className="font-heading text-2xl font-extrabold tracking-tight">Métricas de la red</h1>
            <p className="text-xs c-muted">Sin cuentas demo ni de prueba</p>
          </div>
        </div>
        {err === "forbidden" ? (
          <div data-testid="admin-forbidden" className="c-card p-6 text-center space-y-2"><ShieldAlert className="w-8 h-8 mx-auto c-muted" /><p className="text-sm c-text-2">Solo para administradores.</p></div>
        ) : err ? <p className="c-card p-4 text-sm text-red-600">{err}</p> : !m ? (
          <div className="py-16 flex justify-center"><Loader2 className="w-6 h-6 animate-spin c-muted" /></div>
        ) : (
          <>
            <div data-testid="admin-tabs" className="flex gap-1 p-1 c-card w-fit">
              {TABS.map(([k, l]) => (
                <button key={k} data-testid={`admin-tab-${k}`} onClick={() => setTab(k)}
                  className={`px-4 py-1.5 rounded-lg text-sm font-semibold transition-colors ${tab === k ? "bg-[var(--c-navy)] text-white" : "c-text-2"}`}>{l}</button>
              ))}
            </div>
            {tab === "usuarios" ? <UsersTab /> : <>
            <MetricCards m={m} />
            <DailyChart serie={m.serie} />
            <PendingList items={m.sin_activar} />
            <ConfigControls m={m} onSaved={load} />
            <ExtraInvites onSaved={load} />
            <AuditList items={audit} />
            </>}
          </>
        )}
        <p className="text-center text-[10px] c-muted pt-4">Powered by NAMTECH</p>
      </div>
    </div>
  );
}
